/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteIcon20Solid = forwardRef('CertRosetteIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.563 7.764a3.437 3.437 0 1 1 6.875 0 3.437 3.437 0 0 1-6.875 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.236 7.764a6.74 6.74 0 0 0 1.735 4.523l-1.826 2.608a1.25 1.25 0 0 0 .307 1.741l2.57 1.8a1.25 1.25 0 0 0 1.74-.308l2.236-3.192 2.235 3.192a1.25 1.25 0 0 0 1.741.307l2.57-1.799a1.25 1.25 0 0 0 .307-1.74l-1.824-2.606a6.764 6.764 0 1 0-11.79-4.527ZM10 3.199a4.565 4.565 0 1 0 0 9.13 4.565 4.565 0 0 0 0-9.13Z" })));
});
